<template>
  <div>{{ slotParams.value.toString() }}</div>
</template>
<script>
export default {
  props: ['slotParams'],
};
</script>